import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../interface';
import { updateOptinsStatusThunk } from '../thunks/optins.thunk';
import { getOptinsStatusThunk } from '../thunks/optins.thunk';
export const initialState = {
  updateOptinsStatus: {
    status: RequestStatus.IDLE
  },
  optinsStatus: {
    status: RequestStatus.IDLE
  }
};
export const optinsSliceName = 'optins';
export const {
  actions,
  reducer
} = createSlice({
  name: optinsSliceName,
  initialState,
  reducers: {},
  extraReducers: builder => {
    // UPDATE OPTINS STATUS
    builder.addCase(updateOptinsStatusThunk.pending, state => {
      state.updateOptinsStatus.status = RequestStatus.LOADING;
    });
    builder.addCase(updateOptinsStatusThunk.fulfilled, state => {
      state.updateOptinsStatus.status = RequestStatus.SUCCESS;
    });
    builder.addCase(updateOptinsStatusThunk.rejected, state => {
      state.updateOptinsStatus.status = RequestStatus.ERROR;
    });

    // GET OPTINS STATUS
    builder.addCase(getOptinsStatusThunk.pending, state => {
      state.optinsStatus.status = RequestStatus.LOADING;
    });
    builder.addCase(getOptinsStatusThunk.fulfilled, (state, action) => {
      state.optinsStatus.status = RequestStatus.SUCCESS;
      state.optinsStatus.data = action.payload;
    });
    builder.addCase(getOptinsStatusThunk.rejected, state => {
      state.optinsStatus.status = RequestStatus.ERROR;
    });
  }
});